
import { Component, computed, inject } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { SchedulerFormService } from '../../services/scheduler-form.service';
import { filter, startWith, switchMap } from 'rxjs';
import { MDHeaderComponent } from '@melodic-ui/components';
import { AnnouncementBannerComponent } from '@lb/components/announcement-banner/announcement-banner.component';
import { ScheduleBaseCalendarComponent } from '../schedule-base-calendar/schedule-base-calendar.component';
import { SchedulerStateService } from '@lb/schedule/services/scheduler-state.service';

@Component({
	selector: 'lb-schedule-calendar',
	standalone: true,
	imports: [MDHeaderComponent, AnnouncementBannerComponent, ScheduleBaseCalendarComponent],
	templateUrl: './schedule-calendar.component.html',
	styleUrls: ['./schedule-calendar.component.scss']
})
export class ScheduleCalendarComponent {
	private readonly _schedulerFormService = inject(SchedulerFormService);
	private readonly _scheduleStateService = inject(SchedulerStateService);

	public readonly formStep = 3;
	private readonly _scheduleFormSignal = toSignal(
		toObservable(this._schedulerFormService.step3Form).pipe(
			filter((form) => !!form),
			switchMap((form) => form.valueChanges.pipe(startWith(form.value)))
		),
		{ initialValue: undefined }
	);

	private readonly step2FormSignal = toSignal(
		toObservable(this._schedulerFormService.step2Form).pipe(
			filter((form) => !!form),
			switchMap((form) => form.valueChanges.pipe(startWith(form.value)))
		),
		{ initialValue: undefined }
	);

	selectedSchedules = computed<string[]>(() => {
		const formValue = this._scheduleFormSignal();
		if (formValue) {
			return formValue.map((group: any) => group.id);
		}

		return [];
	});

	preferredTimeSlots = computed<{ dayIndex: number; timeID: string }[]>(() => this.step2FormSignal() as Array<{ dayIndex: number; timeID: string }>);
	lessonsFrequency = computed(() => this._schedulerFormService.getFormData().configuration?.frequency || 0);

	isAdminScheduler = this._scheduleStateService.isAdmin;

	public clearSelection() {
		this._schedulerFormService.clearAllScheduleSelections(this.formStep);
	}

	public removeScheduleSelection(event: { scheduleID: string; step: number }) {
		this._schedulerFormService.removeScheduleSelection(event.scheduleID, event.step);
	}

	public addScheduleSelection(event: { scheduleData: { dayIndex: number; timeID: string }; step: number }) {
		this._schedulerFormService.addScheduleSelection(event.scheduleData, event.step);
	}
}
